import PropTypes from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * @deprecated
  * Please use size props instead
  */
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'large', 'extra-large']), 'Please use size props instead'),

  /**
  * The visual style of the Loader
  */
  size: PropTypes.oneOf(['standard', 'large', 'extra-large']),

  /**
  * Whether or not the Loader should be horizontally centered within its container
  */
  centered: PropTypes.bool,

  /**
  * Whether or not the Loader should be rendered inline with other elements
  */
  inline: PropTypes.bool
};
var Preloader = createComponent({
  displayName: 'Preloader',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var _props$sizeVariant = props.sizeVariant,
          sizeVariant = _props$sizeVariant === void 0 ? 'standard' : _props$sizeVariant,
          _props$size = props.size,
          size = _props$size === void 0 ? sizeVariant : _props$size,
          centered = props.centered,
          inline = props.inline;
      var classNameSet = new Set(['swan-preloader-graphic']);
      if (size !== 'standard') classNameSet.add("swan-preloader-graphic-".concat(size));
      if (centered) classNameSet.add('swan-preloader-graphic-center');
      if (inline) classNameSet.add('swan-preloader-graphic-inline');
      return classNameSet;
    },
    processProps: function processProps(props) {
      return _object_spread_props(_object_spread({}, props), {
        'aria-live': 'polite',
        role: 'status',
        as: props.as || props.component || (props.inline ? 'span' : 'div')
      });
    }
  }
});
Preloader.defaultProps = {
  inline: false,
  centered: false,
  sizeVariant: 'standard',
  size: 'standard'
};
export { Preloader, propTypes };